// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component, createRef } from "react";

import { throttle } from "lodash-es";
import * as pdfjs from "pdfjs-dist/webpack.mjs";
import PropTypes from "prop-types";

const SET_DIMENSIONS_THROTTLE = 300;

export class PDFPage extends Component {
  static propTypes = {
    page: PropTypes.object,
  };

  state = {
    width: 0,
    height: 0,
    viewport: null,
  };

  page = createRef(null);
  canvas = createRef(null);
  textLayer = createRef(null);

  setDimensions = throttle(
    () => {
      const { page } = this.props;
      if (!page || !this.page.current) {
        return;
      }
      const { offsetWidth: width } = this.page.current;
      const viewport = page.getViewport({
        scale: width / page.getViewport({ scale: 1.0 }).width,
      });
      this.setStateSafely({ width, height: viewport.height, viewport });
    },
    SET_DIMENSIONS_THROTTLE,
    { tailing: false, leading: false }
  );

  componentDidMount() {
    this.isStillMounted = true;
    window.addEventListener("resize", this.setDimensions);
    this.setDimensions();
  }

  componentWillUnmount() {
    this.isStillMounted = false;
    window.removeEventListener("resize", this.setDimensions);
  }

  async componentDidUpdate() {
    const { page } = this.props;
    const { viewport } = this.state;
    if (!viewport || !page) {
      return;
    }
    const canvasContext = this.canvas.current?.getContext("2d");
    const container = this.textLayer.current;
    const textContentSource = await page.getTextContent();
    canvasContext.clearRect(0, 0, viewport.width, viewport.height);
    page.render({ canvasContext, viewport });

    const textLayer = new pdfjs.TextLayer({
      textContentSource,
      viewport,
      container,
    });

    await textLayer.render();
  }

  setStateSafely(state) {
    if (this.isStillMounted) {
      this.setState(state);
    }
  }

  render() {
    const { width, height } = this.state;

    return (
      <div ref={this.page} style={{ position: "relative" }}>
        <canvas ref={this.canvas} width={width} height={height} />
        <div ref={this.textLayer} className="textLayer" />
      </div>
    );
  }
}
